import { useCallback } from 'react';

import clsx from 'clsx';

import { VisuallyHidden } from '~/shared/components/VisuallyHidden/VisuallyHidden';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import useMainMenuState from './../../useMainMenuState';
import styles from './mainMenuToggle.module.css';

type IMainMenuToggle = {
	onClick?: () => void;
};

export const MENU_ID = 'rdg-navigation';

const MainMenuToggle = ({ onClick }: IMainMenuToggle) => {
	const { translate } = useTranslation();
	const menuIsOpen = useMainMenuState((state) => state.menuIsOpen);
	const { setMenuIsOpen, clearMainMenuStates } = useMainMenuState((state) => ({
		setMenuIsOpen: state.setMenuIsOpen,
		clearMainMenuStates: state.clearMainMenuStates,
	}));

	const toggleMenuIsOpen = useCallback(() => {
		onClick?.();

		if (menuIsOpen) {
			return clearMainMenuStates();
		}

		// ensure scroll is triggered if metaMenu is still visible
		// mainNavigationTopOffset is 40px (--spacing-06)
		window.document.documentElement.scrollTo({ top: -40, behavior: 'smooth' });

		setMenuIsOpen(true);
	}, [clearMainMenuStates, menuIsOpen, onClick, setMenuIsOpen]);

	return (
		<button
			className={clsx(styles.toggleMenuButton, { [styles.open]: menuIsOpen })}
			type="button"
			onClick={toggleMenuIsOpen}
			aria-expanded={menuIsOpen}
			aria-controls={MENU_ID}
			aria-label={translate('mobile-navigation.open-menu')}
		>
			<span />
			<span />
			<span />

			<VisuallyHidden>{translate('mobile-navigation.open-menu')}</VisuallyHidden>
		</button>
	);
};

export default MainMenuToggle;
